import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import { playWalletAddressVar } from 'shared/store/play-wallet'
import { userVar } from 'shared/store/user'
import { rememberWalletApp } from 'shared/store/wallet-choice'

/**
 * Publishes the wallet that plays (the connected one while it is linked) and
 * remembers which wallet app holds each connected address, so the wallets
 * dialog can connect it again later.
 */
export const usePlayWalletSync = () => {
  const user = useReactiveVar(userVar)
  const { publicKey, wallet } = useWallet()
  const connectedAddress = publicKey?.toBase58() ?? null
  const wallets = user?.wallets

  useEffect(() => {
    const isLinked = Boolean(
      connectedAddress &&
      wallets?.some(linked => linked.address === connectedAddress)
    )

    playWalletAddressVar(isLinked ? connectedAddress : null)
  }, [wallets, connectedAddress])

  useEffect(() => {
    const adapter = wallet?.adapter
    // NOTE: right after a switch the provider reports the new adapter with
    // the previous wallet's key for one render; only a matching pair counts
    if (
      !connectedAddress ||
      adapter?.publicKey?.toBase58() !== connectedAddress
    )
      return

    rememberWalletApp(connectedAddress, adapter.name)
  }, [connectedAddress, wallet])
}
